/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _classCallCheck = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/inherits");

var ControllerProofPurpose = require('./ControllerProofPurpose');

module.exports =
/*#__PURE__*/
function (_ControllerProofPurpo) {
  _inherits(AssertionProofPurpose, _ControllerProofPurpo);

  function AssertionProofPurpose() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$term = _ref.term,
        term = _ref$term === void 0 ? 'assertionMethod' : _ref$term,
        controller = _ref.controller,
        date = _ref.date,
        _ref$maxTimestampDelt = _ref.maxTimestampDelta,
        maxTimestampDelta = _ref$maxTimestampDelt === void 0 ? Infinity : _ref$maxTimestampDelt;

    _classCallCheck(this, AssertionProofPurpose);

    return _possibleConstructorReturn(this, _getPrototypeOf(AssertionProofPurpose).call(this, {
      term: term,
      controller: controller,
      date: date,
      maxTimestampDelta: maxTimestampDelta
    }));
  }

  return AssertionProofPurpose;
}(ControllerProofPurpose);